import { nfdMint, MintRequestBody } from 'api/api-client'
import { MutationOptions, usePostTransaction } from './usePostTransaction'

export function usePostMint(options: MutationOptions<MintRequestBody> = {}) {
  return usePostTransaction<MintRequestBody>({
    mutationFn: (params) => nfdMint(params),
    ...options
  })
}
